"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isXPublishHoldMarker = exports.X_PUBLISH_HOLD_MARKER = exports.X_PUBLISH_HOLD_STATUS_DETAIL = exports.X_PUBLISH_STATUS_HELD = exports.X_PUBLISHING_FEATURE_FLAG = exports.X_SPEND_CAP_USD = exports.X_SPEND_ALERT_THRESHOLD_USD = exports.X_API_UNIT_COSTS_USD = void 0;
/**
 * X API pay-per-use unit costs (USD) from the X Integration PRD (Epic 6).
 * Used to classify and meter calls for the $35 add-on margin check.
 */
exports.X_API_UNIT_COSTS_USD = {
    create_post: 0.015,
    create_post_link: 0.2,
    read_post: 0.005,
    read_user: 0.01,
    read_owned: 0.001,
    /** Media upload billed with create; logged at $0 for volume visibility. */
    media_upload: 0,
    oauth: 0,
};
/** Default MTD spend alert threshold (PRD X-6.4): ~$15 vs ~$60 breakeven. Notify-only. */
exports.X_SPEND_ALERT_THRESHOLD_USD = 15;
/**
 * Hard monthly spend cap (PRD: degrade to queueing, not silent fail).
 * Defaults to the $35 base add-on price so we stop publishing before margin flips.
 */
exports.X_SPEND_CAP_USD = 35;
exports.X_PUBLISHING_FEATURE_FLAG = "XPublishingEnabled";
/** posts.metadata.publishStatus while an X post is held for spend/kill-switch. */
exports.X_PUBLISH_STATUS_HELD = "held";
exports.X_PUBLISH_HOLD_STATUS_DETAIL = {
    kill_switch: "Held — X publishing is paused by the platform. Stays queued until publishing is re-enabled.",
    spend_cap: "Held — monthly X API spend cap reached. Stays queued and retries at the start of next month.",
};
/** Machine-readable markers returned on PlatformPostResult / metadata.errorMessage. */
exports.X_PUBLISH_HOLD_MARKER = {
    kill_switch: "XPublishingEnabled=false",
    spend_cap: "XSpendCapExceeded",
};
const isXPublishHoldMarker = (message) => {
    if (!message) {
        return null;
    }
    if (message.includes(exports.X_PUBLISH_HOLD_MARKER.kill_switch) ||
        message.includes("X publishing is temporarily disabled")) {
        return "kill_switch";
    }
    if (message.includes(exports.X_PUBLISH_HOLD_MARKER.spend_cap) ||
        message.includes("X API spend cap")) {
        return "spend_cap";
    }
    return null;
};
exports.isXPublishHoldMarker = isXPublishHoldMarker;
